import PropTypes from "prop-types";
import { Card, CardContent } from "../ui/card";

function HorizontalNewsCard({ image, title, source, link = "#" }) {
  return (
    <a onClick={()=>window.open(link,"_blank")} className="block hover:opacity-95 transition-opacity">
      <Card className="overflow-hidden border-0 shadow-md w-full h-[100px] flex-shrink-0 rounded-2xl">
        <CardContent className="p-0 flex items-center gap-4 h-full">
          <div className="relative w-[80px] h-[80px] flex-shrink-0 ml-1">
            <img
              src={image || "/placeholder.svg"}
              alt={title}
              className="object-cover rounded-xl w-full h-full"
            />
          </div>
          <div className="flex-1 min-w-0 max-w-[480px]">
            <h3 className="text-base font-semibold line-clamp-2 leading-tight">
              {title}
            </h3>
            <p className="text-gray-400 text-sm mt-1">{source}</p>
          </div>
        </CardContent>
      </Card>
    </a>
  );
}

HorizontalNewsCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  link: PropTypes.string,
};

export default HorizontalNewsCard;
